<template>
  <v-container fluid fill-height class="page__login page__reset-password px-3">
    <v-layout align-center justify-center>
      <div class="login">
        <img src="@/assets/img/99icon_black.svg" alt="99 Empresas" title="99 Empresas" class="login__brand">

        <div v-if="isSuccess">
          <Form v-if="form" :data="data" @toogleContainer="toogleContainer" />
          <Success v-if="success" :data="data" />
        </div>

        <v-layout v-if="isFailed" class="wrapper" align-center justify-center column fill-height>
          {{ $t('Common.genericErrorMsg') }}<br>
          <a
            :title="$t('Common.tryAgain')"
            class="accent--text"
            @click.prevent="getCompanyNameFirstAccess"
          >
            {{ $t('Common.tryAgain') }}.
          </a>
        </v-layout>

        <v-layout v-if="isLoading" class="wrapper" align-center justify-center column fill-height>
          <v-progress-circular indeterminate color="accent" />
        </v-layout>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isObject } from 'utils/functions'
import Form from 'components/firstAccess/Form'
import Success from 'components/firstAccess/Success'

export default {
  name: 'FirstAccessPage',
  components: {
    Form,
    Success
  },
  computed: {
    routeParams () {
      const { employeeId = null, token = null } = this.$route.params
      return {
        employeeId: employeeId ? Number(employeeId) : null,
        token
      }
    },

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.FirstAccessPage',
      currentStatus: null,
      form: true,
      success: false,
      companyName: null,
      data: {}
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    hasValidToken () {
      this.showAlert({
        type: 'info',
        message: this.$t(`${this.namespace}.form.invalidToken`),
        timeout: 8000
      })

      this.$router.push({ name: 'Login' })
    },

    toogleContainer (data) {
      this.form = false
      this.success = true

      if (this.isValidObject(data)) {
        this.data = {
          ...this.data,
          ...data
        }
      }
    },

    async getCompanyNameFirstAccess () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const { employeeId, token: firstAccessToken } = this.routeParams
        const { data: res } = await this.$apiService.getCompanyNameFirstAccess(employeeId, {
          firstAccessToken
        })

        if (!res || res.status !== 'success') {
          throw new Error()
        }

        this.data = { ...res.data }
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        if (err && err.response && err.response.status === 403) {
          this.hasValidToken()
          return
        }
        this.currentStatus = STATUS_FAILED
      }
    }
  },
  mounted () {
    this.getCompanyNameFirstAccess()
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  min-height: 300px;
}
</style>
